<template>
    <!-- Reservas recibidas: el diseño y la lógica están en ReservasCuenta. -->
    <ReservasCuenta tipo="recibidas" />
</template>

<script>
import ReservasCuenta from '@/components/Cuenta/ReservasCuenta.vue';

export default {
    name: 'ReceivedReservationsList',
    components: { ReservasCuenta },
};
</script>

<style src="../../components/BankInformation/bkCuenta.css"></style>
<style src="../../components/Cuenta/cuentaMenu.css"></style>
